<template>
  <div id="app">
      <Header></Header>
      <router-view/>
      <Footer></Footer>
  </div>
</template>

<script>
import Header from './views/Header.vue'
import Footer from './views/Footer.vue'
export default {
  name: 'App',
    provide (){
        return {
            reload:this.reload
        }
    },
  data() {
    return {
      path: "",
      isRouterAlive:true
    }
  },
  components: {
    Footer,
    Header
  },
  mounted() {
    this.path = this.$route.path; /*this.path 为当前页面的路由 */
  },
    methods:{
        reload (){
            this.isRouterAlive = false
            this.$nextTick(function(){
                this.isRouterAlive = true
            })
        }
    },
  /*监测路由的变化 */
  watch: {
    $route(to, from) {
      this.path = to.path;
    }
  },

}
</script>

<style>
body{
    background-color: #ffffff;
}
</style>
